var constants = {
  map: {
    API_ENDPOINT: '//www.bing.com/api/maps/mapcontrol?branch=release',
    CHUNK_INCREMENT: 2,
    DEFAULT_LAT: 39.407547,
    DEFAULT_LON: -94.2591867,
    DEFAULT_LOAD_CALLBACK: 'bingMapsLoaded',
    DEFAULT_OPTIONS: {
      disableScrollWheelZoom: true,
      enableClickableLogo: false,
      maxZoom: 9,
      padding: 30,
      showCopyright: false,
      showLocateMeButton: false,
      showMapTypeSelector: false,
      showZoomButtons: true,
      zoom: 3,
    },
    MOBILE_BREAKPOINT: 767,
    PIN_ANCHOR: {
      x: 15,
      y: 36,
    },
    PIN_COLORS: {
      DEFAULT: '#5d6061',
      SELECTED: '#000',
      PREFERRED: '#f30000',
    },
    PIN_TEXT_OFFSET: {
      x: 0,
      y: 8,
    },
  },
  global: {
    INTERNET_CERTIFIED: '01',
    CTA_RAQ_BEHAVIOR: 'raq',
    CTA_NON_SERVICE_ONLY: 'non-service-only',
    ENDPOINT: '/platform/api/v1/dealer?productDivisionCode=',
    GEOLOCATION_ENDPOINT: '/platform/api/v1/zipcode/ip',
    ZIPCODE_PARAM: 'zipcode',
    CONFIG_GUID_PARAM: 'configGUID',
    START_RESERVATION_FILTER_CODE: 'VD',
  },
  dev: {
    BASE_URL: 'https://ca3-new-acura.possible.com',
  },
};

module.exports = constants;
